import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=132fac5e"
import script from "./claims.vue?vue&type=script&lang=js"
export * from "./claims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports